import cn from 'classnames/bind';
import Image from "next/legacy/image";
import PropTypes from 'prop-types';
import { childrenType, colorType } from 'utils/types';

import s from './Avatar.module.scss';

const cx = cn.bind(s);

const Avatar = ({
  children,
  size = 50,
  color,
  isImage,
  src,
  alt,
  fill = false,
  isUserAvatar = false,
  isUnknownAvatar = false,
}) => {
  const styles = size !== 0 ? { width: `${size}px`, height: `${size}px` } : {};
  return (
    <div
      className={cx('avatar', 'flex-none', color, {
        isImage,
        isUserAvatar,
        isUnknownAvatar,
        fill,
        autoSize: !size,
      })}
      style={styles}
    >
      <div className={cx('avatarInner')}>
        {src ? <Image src={src} alt={alt} layout="fill" objectFit="cover" /> : children}
      </div>
    </div>
  );
};

Avatar.propTypes = {
  size: PropTypes.number,
  children: childrenType,
  color: colorType,
  alt: PropTypes.string,
  fill: PropTypes.bool,
};
export default Avatar;
